import { FC } from 'react';
import { generalHelpers } from '@monorepo/helpers';
import { typeForecast } from '@monorepo/models';
import { useGetIsDarkMode, useGetIsMobile } from 'src/custom-hooks';

type propsType = {
    forecasts: typeForecast[];
};

export const Forecast: FC<propsType> = ({ forecasts }) => {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);
    const twoDays = new Date(today);
    twoDays.setDate(today.getDate() + 2);
    //
    const forecastToday = forecasts.filter(x => x.date.fullDate === generalHelpers.FormatDate(today) && x.date.hour >= 6);
    const forecastTomorrow = forecasts.filter(x => x.date.fullDate === generalHelpers.FormatDate(tomorrow) && x.date.hour >= 6);
    const forecastTwoDays = forecasts.filter(x => x.date.fullDate === generalHelpers.FormatDate(twoDays) && x.date.hour >= 6);
    const isDarkMode = useGetIsDarkMode();
    const isMobile = useGetIsMobile();

    const divStyles = {
        display: isMobile ? undefined : 'flex',
        gap: '1rem',
        justifyContent: 'center',
        marginBottom: '2.5rem',
        marginTop: isMobile ? undefined : '2.1rem',
        padding: isMobile ? '.2rem' : undefined,
        width: isMobile ? '100%' : undefined
    };

    return (
        <div className={`text-center p-0 animate__animated animate__bounceInDown ${isMobile ? 'mt-0' : 'mt-5'}`}>
            {!!forecastToday.length &&
                <>
                <h1 className={isDarkMode ? 'text-white' : ''}>
                    Hoy
                </h1>
                <div style={{ ...divStyles }}>
                    {forecastToday.map(forecast =>
                        <ForecastCard key={`${forecast.date?.day}-${forecast.date?.hour}`} forecast={forecast} />
                    )}
                </div>
                </>
            }
            {!!forecastTomorrow.length &&
                <>
                <h1 className={isDarkMode ? 'text-white' : ''}>
                    Mañana
                </h1>
                <div style={{ ...divStyles }}>
                    {forecastTomorrow.map(f =>
                        <ForecastCard key={`${f.date?.day}-${f.date?.hour}`} forecast={f} />
                    )}
                </div>
                </>
            }
            {!!forecastTwoDays.length &&
                <>
                <h1 className={isDarkMode ? 'text-white' : ''}>
                    {forecasts.find(x => x.date.dateDay === new Date().getDate() + 2 && x.date.hour > 6)?.date.weekday}
                </h1>
                <div style={{ ...divStyles }}>
                    {forecastTwoDays.map(f =>
                        <ForecastCard key={`${f.date?.day}-${f.date?.hour}`} forecast={f} />
                    )}
                </div>
                </>
            }
        </div>
    );
}

type propsType1 = {
    forecast: typeForecast;
};

const ForecastCard: FC<propsType1> = ({ forecast }) => {
    const isMobile = useGetIsMobile();

    return (
        <div
            className={forecast.temperatures > 29 ? 'animate__animated animate__pulse animate__infinite	infinite' : ''}
            style={{
                alignItems: 'center',
                backgroundColor: '#fff',
                borderRadius: '0.25rem',
                boxShadow: 'rgba(0, 0, 0, 0.05) 0 6px 24px 0, rgba(0, 0, 0, 0.08) 0 0 0 1px',
                cursor: 'pointer',
                display: 'flex',
                flexDirection: isMobile ? 'row' : 'column',
                gap: '0.5rem',
                justifyContent: 'center',
                padding: isMobile ? '.5rem .75rem' : '1rem 0.75rem',
                transition: 'all 0.2s ease',
                width: isMobile ? '100%' : '200px'
            }}
        >
            {/* <h6 className={isMobile ? 'my-auto' : undefined} style={{ order: isMobile ? 2 : undefined }}>
                {forecast.date?.weekday}
            </h6> */}
            <h6 className={isMobile ? 'my-auto' : ''} style={{ order: isMobile ? 3 : undefined }}>
                {forecast.date?.hour < 12 ? '0' : ''}{forecast.date?.hour}:00 hs{isMobile ? ':' : ''}
            </h6>
            {isMobile ?
                <div style={{ order: 1, width: isMobile ? '40px' : undefined }}>
                    {forecast.icon as JSX.Element}
                </div>
                :
                <>{forecast.icon}</>
            }
            <h6 className={'mt-2 d-block align-items-end'} style={{ order: isMobile ? 4 : undefined }}>
                {forecast.temperatures}ºC
            </h6>
            <p className={`${forecast.pop ? '' : 'text-white'} ${isMobile ? 'my-auto' : ''}`}
                style={{ order: isMobile ? 5 : undefined }}
            >
                {forecast.pop ? `(Lluvia: ${Math.round(forecast.pop * 100)}%)` : ''}
            </p>
        </div>
    );
}
